import { view } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import getDefaultTraits from 'src/js/modules/analytics/segment/helpers/get-default-traits';
import getCaptionForElement from 'src/js/modules/common/helpers/get-caption-for-element';

const { track, constants } = segment;

const trackWidgetDragInitiated = ({ elementId, breakpointType }) => {
  const element = view.accessors.getLiveElement(elementId);

  track(constants.events.WIDGET_DRAG_INITIATED, {
    ...getDefaultTraits(elementId),
    elementId: getCaptionForElement(element).id,
    ...(breakpointType && { breakpointType }),
  });
};

export default trackWidgetDragInitiated;
